<template>
  <KeepAlive>
    <div :class="{ 'isDark': darkmode }">
      <i v-if="pauseDuration > 30" class="fas fa-bed"></i>
      <i v-else-if="pauseDuration < 3" class="fas fa-running"></i>
      <i v-else class="fas fa-male" />
    </div>
  </KeepAlive>
</template>

<script>
import { mapGetters } from 'vuex'
import L from 'leaflet'
import moment from 'moment'
export default {
  props: {
    darkmode: {
      type: Boolean,
    },
    deviceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      knownPosition: null,
      distanceFrom: null,
      pauseTime: null,
    }
  },
  computed: {
    ...mapGetters([
      'positions'
    ]),
    newPosition() {
      return this.positions[this.deviceId]
    },
    pauseDuration() {
      if (moment(this.newPosition.fixTime).diff(moment(this.pauseTime)) < 3000) {
        return moment().diff(moment(this.pauseTime), 'minutes')
      }
      return moment(this.newPosition.fixTime).diff(moment(this.pauseTime), 'minutes')
    },
  },
  mounted() {
    this.knownPosition = L.point([this.positions[this.deviceId].latitude, this.positions[this.deviceId].longitude])
    this.pauseTime = this.positions[this.deviceId].fixTime
  },
  watch: {
    newPosition() {
      this.distanceFrom = L.point([this.newPosition.latitude, this.newPosition.longitude]).distanceTo(this.knownPosition)
      if (this.distanceFrom > 0.001) {
        this.pauseTime = this.newPosition.fixTime
        this.knownPosition = L.point([this.newPosition.latitude, this.newPosition.longitude])
      }
      // if (moment(this.newPosition.fixTime).diff(moment(this.pauseTime)) > 0 ) {
      //   this.pauseDuration = moment(this.newPosition.fixTime).diff(moment(this.pauseTime))
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.isDark {
  text-shadow: 0 0 5px #000, 0 0 5px #000, 0 0 5px #000, 0 0 5px #000;
}
</style>